import { Group, Stack, Text } from "@mantine/core";
import type { JSX } from "react";
import { useVerifiedCustomerStore } from "@/customer-info";
import { useSessionId } from "@/sdk";
import { LightBulb } from "./icons/LightBulb";
import { digitalCompetencyDescriptions } from "./types";

export function DigitalCompetency(): JSX.Element | null {
    const sessionId = useSessionId();
    const digitalCompetency = useVerifiedCustomerStore(
        (state) => state.getVerifiedCustomer(sessionId).customer?.digitalCompetency,
    );
    return (
        <Stack gap="xs">
            <Text size="0.75rem" fw="700" c="dark.2">
                Insights
            </Text>
            <Group align="flex-start" gap="0.25rem">
                <LightBulb />
                <Stack gap="0.5rem" w="90%">
                    {digitalCompetency && (
                        <Text size="xs" fw="700">
                            {digitalCompetency}
                        </Text>
                    )}
                    <Text size="xs" c="dark.2">
                        {digitalCompetency ? digitalCompetencyDescriptions[digitalCompetency] : "Waiting for insights"}
                    </Text>
                </Stack>
            </Group>
        </Stack>
    );
}
